import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderCmsModule } from '../../util/cms-module-renderer'

import Header from '../../components/molecules/Header/Header'

import {
  CalendarPageContainer,
  CalendarPageInnerContainer,
} from './CalendarPage.css.js';

class CalendarPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      header,
      page,
    } = this.props.content;

    return (
      <div>
        <Header
          {...header}
        />
        
        {page.pageHero && renderCmsModule(page.pageHero)}

        <CalendarPageContainer>
          <CalendarPageInnerContainer>
            <iframe
              style={{margin: `0 auto`, display: `table`, border: 0}}
              src="https://calendar.google.com/calendar/embed?src=admissions%40montessoribrooklyn.com&ctz=America/New_York"
              width="800"
              height="600"
              frameborder="0"
              scrolling="no">
            </iframe>
          </CalendarPageInnerContainer>
        </CalendarPageContainer>
      </div>
    );
  }
}

CalendarPage.propTypes = {
  config: PropTypes.shape({
    hasHeader: PropTypes.bool.isRequired,
  }),
  content: PropTypes.shape({
    header: {
      config: PropTypes.shape({
        showLogo: PropTypes.bool,
      }),
      content: PropTypes.shape({
        navigationItems: PropTypes.shape({
          label: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }).isRequired,
      }),
    },
    page: PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      featuredImage: PropTypes.string,
    }).isRequired,
  }),
};

CalendarPage.defaultProps = {
  config: {
    hasHeader: true,
  },
};

export default CalendarPage;